import React from 'react';
import {
  XCircle,
  AlertTriangle,
  CreditCard,
  Calendar,
  ArrowLeft,
  RefreshCw,
} from 'lucide-react';
import '../../styles/PaymentFailure.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDateWithAmPm } from '../../Style';
import { useSelector } from 'react-redux';
import { BOOKINGS } from '../../component/common/Routes/AppRoutes';
import { VENDOR_BOOKINGS } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_BOOKINGS } from '../../component/common/Routes/CustomerRoutes';

const PaymentFailure = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const orderDetails = location.state?.orderData || {};
  const paymentUrl = location.state?.paymentUrl || {};
  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  });
  return (
    <div className='payment-failure-container'>
      <div className='payment-card'>
        {/* Failure Header */}
        <div className='failure-header'>
          <div className='icon-container'>
            <XCircle size={56} strokeWidth={2.5} />
          </div>
          <h1>Payment Failed</h1>
        </div>

        {/* Content */}
        <div className='content'>
          <p className='failure-message'>
            We were unable to process your payment. Please check your payment
            details and try again.
          </p>
          {/* className='detail-value error-code' */}
          {/* Transaction Details */}
          <div className='transaction-details'>
            <h2>Payment Information</h2>

            <div className='detail-row'>
              <div className='detail-label'>
                <AlertTriangle size={18} />
                <span>Error Code</span>
              </div>
              <span>ERR_PAYMENT_DECLINED</span>
            </div>
            <div className='detail-row'>
              <div className='detail-label'>
                <CreditCard size={18} />
                <span>PNR NUMBER</span>
              </div>
              <span className='detail-value amount'>
                {orderDetails?.pnr_number}
              </span>
            </div>
            <div className='detail-row'>
              <div className='detail-label'>
                <CreditCard size={18} />
                <span>Amount</span>
              </div>
              <span className='detail-value amount'>
                {currencyFormatter.format(parseFloat(orderDetails?.total))}
              </span>
            </div>
            <div className='detail-row'>
              <div className='detail-label'>
                <Calendar size={18} />
                <span>Date</span>
              </div>
              <span className='detail-value'>
                {formatDateWithAmPm(orderDetails?.created_at)}
              </span>
            </div>
          </div>
          <div className='error-notification'>
            <p>
              <strong>Possible reasons for failure:</strong> Insufficient funds,
              expired card, incorrect card details, or transaction blocked by
              your bank.
            </p>
          </div>
          {/* Action Buttons */}
          <div className='action-buttons'>
            <button
              className='cancel-button'
              onClick={() => {
                if (paymentUrl) {
                  window.location.href = paymentUrl;
                }
              }}
            >
              <RefreshCw size={18} />
              <span>Try Again</span>
            </button>
            <button
              className='btn secondary'
              onClick={() => {
                let bookingsRoute;

                if (user.role === 'Admin' || user.role === 'Staff') {
                  bookingsRoute = BOOKINGS;
                } else if (user.role === 'Vendor') {
                  bookingsRoute = VENDOR_BOOKINGS;
                } else if (user.role === 'Customer') {
                  bookingsRoute = CUSTOMER_BOOKINGS;
                }
                navigate(bookingsRoute);
              }}
            >
              <ArrowLeft size={18} />
              <span>Back to Booking</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
